/* ==========================================================================
   Towelling Totes — theme behaviour

   Ported from the static design, with one substantive change: the bag is no
   longer localStorage. Every add/change/remove goes through Shopify's real
   cart, and the drawer is re-rendered server-side via the Section Rendering
   API so prices, discounts and currency always come from Liquid rather than
   being formatted twice in two places.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- toast ---------------- */
  var toastEl = $('#toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    $('#toastTxt').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------------- header scroll state ---------------- */
  var head = $('#head');
  if (head && head.dataset.transparent === 'true') {
    var onScroll = function () {
      head.classList.toggle('solid', window.scrollY > window.innerHeight * 0.72);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- mobile menu ---------------- */
  var menuM = $('#menuM');
  if (menuM) {
    var openMenu = function () { menuM.classList.add('open'); document.body.classList.add('no-scroll'); };
    var closeMenu = function () { menuM.classList.remove('open'); document.body.classList.remove('no-scroll'); };
    var burger = $('#burger');
    var menuClose = $('#menuClose');
    if (burger) burger.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    $$('a', menuM).forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* ---------------- search overlay ---------------- */
  var searchPop = $('#searchPop');
  var searchBtn = $('#searchBtn');
  if (searchPop && searchBtn) {
    var openSearch = function () {
      searchPop.classList.add('open');
      document.body.classList.add('no-scroll');
      var i = $('#searchInput');
      if (i) setTimeout(function () { i.focus(); }, 60);
    };
    var closeSearch = function () {
      searchPop.classList.remove('open');
      document.body.classList.remove('no-scroll');
    };
    searchBtn.addEventListener('click', openSearch);
    searchPop.addEventListener('click', function (e) {
      if (e.target === searchPop) closeSearch();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  /* ---------------- marquee ---------------- */
  var mq = $('#mq');
  if (mq && mq.dataset.words) {
    var words = mq.dataset.words.split('|').filter(Boolean);
    if (words.length) {
      var seg = '<span>' + words.map(function (w) {
        return escapeHtml(w.trim()) + ' <i class="star">&#10022;</i>';
      }).join(' ') + '</span>';
      mq.innerHTML = seg + seg;
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- campaign parallax ---------------- */
  var campBg = $('#campBg');
  if (campBg && !reduce) {
    var camp = campBg.parentElement;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var r = camp.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          campBg.style.transform = 'translateY(' + (p * -7) + '%)';
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- drop countdown ----------------
     The static design counted to "now + 3 days", which would have reset on
     every page load. This reads a real date set in the theme editor. */
  var countEl = $('#count');
  if (countEl && countEl.dataset.until) {
    var target = new Date(countEl.dataset.until).getTime();
    if (!isNaN(target)) {
      var tick = function () {
        var d = target - Date.now();
        if (d <= 0) { countEl.innerHTML = '<b>' + escapeHtml(countEl.dataset.live || 'now') + '</b>'; return; }
        var dd = Math.floor(d / 864e5),
            hh = Math.floor((d % 864e5) / 36e5),
            mm = Math.floor((d % 36e5) / 6e4),
            ss = Math.floor((d % 6e4) / 1e3);
        countEl.innerHTML = '<b>' + dd + 'd ' + pad(hh) + 'h ' + pad(mm) + 'm ' + pad(ss) + 's</b>';
      };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      tick();
      setInterval(tick, 1000);
    }
  }

  /* ---------------- scroll reveal ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.14 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ==========================================================================
     CART
     ========================================================================== */

  var drawer = $('#cartDrawer');
  var overlay = $('#overlay');

  function openDrawer() {
    if (!drawer) { window.location.href = window.theme.routes.cart_url; return; }
    drawer.classList.add('open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('show'); }); }
    document.body.classList.add('no-scroll');
    var c = $('.drawer-close', drawer);
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('show');
      setTimeout(function () { overlay.hidden = true; }, 350);
    }
    document.body.classList.remove('no-scroll');
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); if (menuM) menuM.classList.remove('open'); document.body.classList.remove('no-scroll'); }
  });

  function setBagCount(n) {
    $$('[data-bag-count]').forEach(function (el) {
      el.textContent = n;
      if (!reduce && el.animate) {
        el.animate([{ transform: 'scale(1.6)' }, { transform: 'scale(1)' }], { duration: 300 });
      }
    });
  }

  /* Replace the drawer markup with freshly-rendered Liquid and rebind. */
  function applySections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (!html || !drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#cartDrawer');
    if (!fresh) return;
    var wasOpen = drawer.classList.contains('open');
    drawer.innerHTML = fresh.innerHTML;
    if (wasOpen) drawer.classList.add('open');
    setBagCount(fresh.dataset.cartCount || '0');
    bindDrawer();
  }

  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function addToCart(id, quantity, label, btn) {
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    return cartRequest(window.theme.routes.cart_add_url, { items: [{ id: id, quantity: quantity || 1 }] })
      .then(function (data) {
        applySections(data.sections);
        toast(label ? label + ' ' + window.theme.strings.addedToBag : window.theme.strings.addedToBag);
        openDrawer();
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); if (btn.dataset.label) btn.textContent = btn.dataset.label; }
      });
  }

  function changeLine(key, quantity, fromCartPage) {
    return cartRequest(window.theme.routes.cart_change_url, { id: key, quantity: quantity })
      .then(function (data) {
        /* The cart page renders its own table, which the drawer section
           cannot refresh. Reload so the totals and line rows stay truthful
           rather than showing a stale subtotal. */
        if (fromCartPage) { window.location.reload(); return; }
        applySections(data.sections);
      })
      .catch(function (err) { toast(err.message); });
  }

  /* Delegated so it survives the drawer being re-rendered. */
  function bindDrawer() {
    if (!drawer) return;
    var c = $('.drawer-close', drawer);
    if (c) c.addEventListener('click', closeDrawer);
  }
  bindDrawer();

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-cart]');
    if (open) { e.preventDefault(); openDrawer(); return; }

    var minus = e.target.closest('[data-line-minus]');
    var plus = e.target.closest('[data-line-plus]');
    var remove = e.target.closest('[data-line-remove]');
    var node = minus || plus || remove;
    if (node) {
      e.preventDefault();
      var key = node.dataset.key;
      var qty = parseInt(node.dataset.qty || '0', 10);
      var onCartPage = !node.closest('#cartDrawer');
      if (remove) return changeLine(key, 0, onCartPage);
      return changeLine(key, minus ? Math.max(0, qty - 1) : qty + 1, onCartPage);
    }

    var close = e.target.closest('.drawer-close');
    if (close) { e.preventDefault(); closeDrawer(); return; }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart(parseInt(quick.dataset.variantId, 10), 1, quick.dataset.label || '', quick);
    }
  });

  /* ==========================================================================
     PRODUCT PAGE
     ========================================================================== */

  var pdp = $('#ProductForm');
  if (pdp) {
    var dataEl = $('#ProductJson');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var variantInput = $('#VariantId');
    var priceEl = $('#pPrice');
    var addBtn = $('#addBtn');
    var qtyInput = $('#qtyInput');
    var mainImg = $('#mainImg');
    var swName = $('#swName');
    var tagEl = $('#pTag');

    /* srcset WINS over src. Setting only .src left the browser rendering the
       original responsive candidate, so clicking a thumbnail appeared to do
       nothing at all. Both have to be cleared/replaced together. */
    function showImage(url, alt) {
      if (!mainImg || !url) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = url;
      if (alt != null) mainImg.alt = alt;
    }

    function currentOptions() {
      return $$('[data-option-index]', pdp).filter(function (el) {
        return el.type !== 'radio' || el.checked;
      }).map(function (el) { return el.value; });
    }

    function findVariant(opts) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      }) || null;
    }

    function updateAddBtn(variant) {
      if (!addBtn) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variant) {
        addBtn.textContent = window.theme.strings.unavailable;
        addBtn.setAttribute('aria-disabled', 'true');
      } else if (!variant.available) {
        addBtn.textContent = window.theme.strings.soldOut;
        addBtn.setAttribute('aria-disabled', 'true');
      } else {
        addBtn.textContent = window.theme.strings.addToBag + ' · ' + formatMoney(variant.price * qty);
        addBtn.removeAttribute('aria-disabled');
      }
    }

    function formatMoney(cents) {
      var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return (window.theme.moneyFormat || '£{{amount}}')
        .replace(/\{\{\s*amount\s*\}\}/, v)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
    }

    function onVariantChange() {
      var variant = findVariant(currentOptions());
      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = formatMoney(variant.price) +
          (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
        if (swName) swName.textContent = variant.title;
        if (tagEl) {
          if (!variant.available) { tagEl.textContent = window.theme.strings.soldOut; tagEl.classList.add('sold'); }
          else { tagEl.textContent = tagEl.dataset.default || ''; tagEl.classList.remove('sold'); }
          tagEl.hidden = !tagEl.textContent;
        }
        if (variant.featured_image && mainImg) {
          showImage(variant.featured_image.src, variant.featured_image.alt || product.title);
          $$('.thumbs button').forEach(function (b) {
            b.classList.toggle('active', b.dataset.mediaId === String(variant.featured_image.id));
          });
        }
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', variant.id);
          history.replaceState({}, '', u.toString());
        }
        /* On a phone the gallery is above the options, so changing a variant
           silently swapped a photo the customer could not see. Bring it back
           into view rather than making them scroll up and down. */
        if (window.matchMedia('(max-width: 900px)').matches) {
          var gal = document.querySelector('.gallery');
          if (gal) {
            gal.scrollIntoView({
              behavior: reduce ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        }
      }
      updateAddBtn(variant);
    }

    $$('[data-option-index]', pdp).forEach(function (el) {
      el.addEventListener('change', onVariantChange);
    });

    /* quantity */
    var qUp = $('#qUp'), qDn = $('#qDn');
    if (qUp) qUp.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      onVariantChange();
    });
    if (qDn) qDn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      onVariantChange();
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      onVariantChange();
    });

    /* gallery thumbs */
    $$('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        showImage(b.dataset.full, b.dataset.alt || '');
        $$('.thumbs button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });

    /* submit through AJAX so we get the drawer instead of a page reload */
    pdp.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = findVariant(currentOptions());
      if (!variant || !variant.available) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(variant.id, qty, product.title + ' · ' + variant.title, addBtn);
    });

    onVariantChange();
  }

  /* ==========================================================================
     NEWSLETTER — inline validation before Shopify's own POST
     ========================================================================== */
  var dropForm = $('#dropForm');
  if (dropForm) {
    dropForm.addEventListener('submit', function (e) {
      var input = $('#dropEmail', dropForm);
      var msg = $('#msg');
      var v = input ? input.value.trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        e.preventDefault();
        if (msg) { msg.textContent = msg.dataset.invalid || 'Please enter a valid email address.'; msg.classList.add('err'); }
        if (input) input.focus();
      }
    });
  }

  /* ---------------- product recommendations ----------------
     Swaps the server-rendered collection fallback for Shopify's own
     recommendations once they are available. If the request fails the
     fallback simply stays, so this can never leave an empty section. */
  var related = $('[data-related]');
  if (related && related.dataset.url) {
    fetch(related.dataset.url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (fresh && fresh.querySelector('.product')) {
          related.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* keep the fallback */ });
  }

  /* ---------------- collection sort ---------------- */
  var sort = $('#SortBy');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
})();
